<div class="match-selector">
  <mat-radio-group [name]="'match-' + groupId" class="match-radio-group">
    <!-- Radio: Create New -->
    <div class="match-radio-wrapper create-new"
         [class.selected]="!blocked && (forcedNew || isCreateNew)"
         [class.disabled]="blocked || exactLocked"
         [title]="blocked ? blockedReason : (exactLocked ? exactLockedReason : '')">
      <mat-radio-button
        [checked]="!blocked && !exactLocked && (forcedNew || isCreateNew)"
        [disabled]="forcedNew || blocked || exactLocked"
        (change)="selectCreateNew()"
        value="new"
        class="platform-radio"
      >
        <div class="radio-content">
          <span class="radio-label">Create New</span>
        </div>
      </mat-radio-button>
    </div>

    <!-- Radio: Link to Existing -->
    <div class="match-radio-wrapper link-existing"
         [class.selected]="!blocked && !forcedNew && !isCreateNew"
         [class.disabled]="forcedNew || !hasMatches || blocked"
         [title]="blocked ? blockedReason : ''">
      <mat-radio-button
        [checked]="!blocked && !forcedNew && !isCreateNew"
        [disabled]="forcedNew || !hasMatches || blocked"
        (change)="selectMatch()"
        value="match"
        class="platform-radio"
      >
        <div class="radio-content">
          <i class="material-symbols-rounded radio-icon">link</i>
          <span class="radio-label">Link to Existing</span>
          @if (!forcedNew && hasMatches) {
            <span class="score-chip" [ngClass]="bestScoreClass">{{ bestScorePercent }}%</span>
          }
        </div>
      </mat-radio-button>
    </div>
  </mat-radio-group>

  <div class="selector-footer">
    @if (blocked) {
      <div class="no-matches-hint">
        <i class="material-symbols-rounded">info</i>
        {{ blockedReason }}
      </div>
    } @else if (forcedNew) {
      <div class="no-matches-hint">
        <i class="material-symbols-rounded">info</i>
        {{ forcedNewReason }}
      </div>
    } @else if (exactLocked) {
      <div class="no-matches-hint">
        <i class="material-symbols-rounded">info</i>
        {{ exactLockedReason }}
      </div>
    } @else if (!hasMatches) {
      <div class="no-matches-hint">
        <i class="material-symbols-rounded">info</i>
        No matches found
      </div>
    }

    <!-- Match dropdown (visible when Link to Existing selected) -->
    @if (showDropdown && !blocked && !forcedNew && !isCreateNew && hasMatches) {
      <div class="match-dropdown-wrapper">
        <app-score-select
          [options]="scoreSelectOptions"
          [value]="currentSelection"
          (valueChange)="onMatchSelected($event)">
        </app-score-select>
      </div>
    }
  </div>
</div>
